// Printable branded receipt for a single named giving record.
// Renders a hidden print-only div and triggers window.print(); a small
// CSS block scopes @media print so ONLY the receipt is visible on paper.

import React from "react";

export function printGivingReceipt({ record, member, appSettings, currencySymbol = "$" }) {
  const churchName = appSettings?.appName || "Kingdom Connect";
  const churchLogo = appSettings?.appLogo || "";
  const memberName = record.isAnonymous
    ? "Anonymous"
    : (member ? `${member.firstName || ""} ${member.lastName || ""}`.trim() : (record.memberId || "—"));
  const amount = `${currencySymbol}${(record.amountCents / 100).toFixed(2)}`;
  const category = record.category === "Other" ? (record.categoryOther || "Other") : record.category;

  const w = window.open("", "_blank", "width=720,height=900");
  if (!w) return;
  w.document.write(`<!doctype html>
<html><head><title>Giving Receipt ${record.transactionRef}</title>
<style>
  * { box-sizing: border-box; }
  body { font-family: Georgia, "Times New Roman", serif; margin: 0; padding: 32px; color: #111; }
  .rcpt { max-width: 640px; margin: 0 auto; border: 2px solid var(--kc-accent); padding: 32px; }
  .rcpt-header { display: flex; align-items: center; gap: 16px; border-bottom: 1px solid var(--kc-accent); padding-bottom: 18px; margin-bottom: 22px; }
  .rcpt-logo { width: 64px; height: 64px; object-fit: contain; }
  .rcpt-church { font-size: 22px; font-weight: 700; color: #8b6914; letter-spacing: 0.5px; }
  .rcpt-tag { font-size: 12px; color: #666; margin-top: 2px; }
  .rcpt-title { font-size: 18px; font-weight: 700; margin: 0 0 4px; text-transform: uppercase; letter-spacing: 1px; }
  .rcpt-ref { font-family: "Courier New", monospace; font-size: 12px; color: #666; margin-bottom: 20px; }
  .rcpt-amount { font-size: 32px; font-weight: 700; color: #8b6914; text-align: center; padding: 18px 0; border-top: 1px dashed #ccc; border-bottom: 1px dashed #ccc; margin: 18px 0; }
  .rcpt-row { display: flex; justify-content: space-between; padding: 8px 0; border-bottom: 1px dotted #ddd; }
  .rcpt-row .k { color: #666; font-size: 13px; }
  .rcpt-row .v { font-weight: 600; text-align: right; }
  .rcpt-footer { margin-top: 24px; padding-top: 16px; border-top: 1px solid var(--kc-accent); text-align: center; font-size: 12px; color: #666; }
  @media print {
    body { padding: 0; }
    .rcpt { border: 2px solid var(--kc-accent); }
    .no-print { display: none; }
  }
</style></head>
<body>
  <div class="rcpt">
    <div class="rcpt-header">
      ${churchLogo ? `<img class="rcpt-logo" src="${churchLogo}" alt="logo"/>` : ""}
      <div>
        <div class="rcpt-church">${escapeHtml(churchName)}</div>
        <div class="rcpt-tag">Official Giving Receipt</div>
      </div>
    </div>
    <h1 class="rcpt-title">Giving Confirmation</h1>
    <div class="rcpt-ref">Ref: ${escapeHtml(record.transactionRef || "—")}</div>
    <div class="rcpt-amount">${escapeHtml(amount)}</div>
    <div class="rcpt-row"><span class="k">Date</span><span class="v">${escapeHtml(record.date || "—")}</span></div>
    <div class="rcpt-row"><span class="k">From</span><span class="v">${escapeHtml(memberName)}</span></div>
    <div class="rcpt-row"><span class="k">Category</span><span class="v">${escapeHtml(category)}</span></div>
    ${record.paymentMethod ? `<div class="rcpt-row"><span class="k">Payment Method</span><span class="v">${escapeHtml(record.paymentMethod)}</span></div>` : ""}
    <div class="rcpt-footer">
      Thank you for your generous giving to ${escapeHtml(churchName)}.<br/>
      Generated ${new Date().toLocaleString()}
    </div>
    <div class="no-print" style="margin-top:24px; text-align:center;">
      <button onclick="window.print()" style="background:var(--kc-accent);color:#111;border:0;padding:10px 22px;border-radius:6px;font-weight:700;cursor:pointer;">Print / Save PDF</button>
      <button onclick="window.close()" style="margin-left:8px;background:transparent;color:#666;border:1px solid #999;padding:10px 22px;border-radius:6px;cursor:pointer;">Close</button>
    </div>
  </div>
  <script>setTimeout(() => window.print(), 350);</script>
</body></html>`);
  w.document.close();
}

function escapeHtml(s) {
  if (s === null || s === undefined) return "";
  return String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
}
